import React from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { IconButton, SwipeableDrawer } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { NavBarContainer, ImgLogo, ButtonNavBar } from './style';
import LogoFayven from '../../assets/img/fayven_logo_2.png';
import UserMenuButton from '../UserMenuButton/UserMenuButton';
import './style.css';
import MobileMenu from './MobileMenu';
import { useIsMobile } from '../../hooks/useIsMobile';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export default function Navbar({ elements, menuItem, action }) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const classes = useStyles();
  const HOME = 'HOME';

  const onChangeUserMenuOptions = () => {};
  const onChangeRoute = (route) => {
    navigate(route);
  };

  return (
    <NavBarContainer isMobile={isMobile}>
      {action ? (
        <IconButton className={classes.root} onClick={() => action(HOME)}>
          <ImgLogo src={LogoFayven} />
        </IconButton>
      ) : (
        <ImgLogo src={LogoFayven} />
      )}
      {isMobile ? (
        <MobileMenu elements={elements} />
      ) : (
        <>
          {elements.map(({ id, route, name, children, onClick }) => (
            <div key={id} className="section">
              {children ?? (
                <ButtonNavBar
                  onClick={() => {
                    if (onClick) {
                      onClick();
                      return;
                    }

                    if (route) onChangeRoute(route);
                  }}>
                  {name}
                </ButtonNavBar>
              )}
            </div>
          ))}
          <div>{menuItem || <UserMenuButton onClick={onChangeUserMenuOptions} />}</div>
        </>
      )}
    </NavBarContainer>
  );
}

Navbar.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      active: PropTypes.bool,
      route: PropTypes.string,
      roles: PropTypes.arrayOf(PropTypes.string),
      onClick: PropTypes.func,
      children: PropTypes.node,
    }),
  ).isRequired,
  menuItem: PropTypes.node,
  action: PropTypes.func,
};

Navbar.defaultProps = {
  menuItem: undefined,
  action: null,
};
